const StoreUnavailable = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="bg-white rounded-xl shadow-md p-8 flex flex-col items-center max-w-md w-full">
          {/* Store Closed Icon */}
          <div className="w-20 h-20 mb-6 bg-red-100 rounded-full flex items-center justify-center">
            <svg
              className="w-12 h-12 text-red-500"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21"
              />
            </svg>
          </div>

          <h1 className="text-2xl font-bold text-gray-800 mb-3 text-center">
            Mağazaya Erişilemiyor
          </h1>

          <p className="text-gray-600 mb-6 text-center leading-relaxed">
            Şu anda mağazamıza erişim sağlanamıyor. Bu geçici bir durum
            olabilir. Lütfen birkaç dakika sonra tekrar deneyin.
          </p>
        </div>
      </div>
    </div>
  );
};

export default StoreUnavailable;
